import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

export default class LoadingIcon extends Component {
  render() {
    let loadingMessage = this.props.message || 'Loading...';
    return (
      <div className="LoadingIcon center">
        <p>{loadingMessage}</p>
        <i className="fas fa-spinner fa-pulse fa-3x"></i>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/LoadingIcon/LoadingIcon.js